import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";


export default function CrudTable({
  data,
  selectedRows,
onSelectRow,
  onEdit,
  onEditLink,
  onDelete,
  onToggleStatus,
  onToggleApprovedStatus,
  columns,
    searchText: externalSearchText, 
   
  startDate: externalStartDate,
  endDate: externalEndDate,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  // SEARCH STATES
 const [internalSearchText, setInternalSearchText] = useState("");
const [openDropdownId, setOpenDropdownId] = useState(null);
const searchText =
  externalSearchText !== undefined
    ? externalSearchText
    : internalSearchText;

const [internalStartDate, setInternalStartDate] = useState("");
const [internalEndDate, setInternalEndDate] = useState("");
const setStartDate = setInternalStartDate;
const setEndDate = setInternalEndDate;
const startDate =
  externalStartDate !== undefined
    ? externalStartDate
    : internalStartDate;

const endDate =
  externalEndDate !== undefined
    ? externalEndDate
    : internalEndDate;


  const handleSettingsClick = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  const handleNavigateToGallery = (id) => {
    navigate(`/admin/product-image-gallery/${id}`);
  };

  const isProductGalleryPage = currentPath.startsWith(
    "/admin/product-image-gallery"
  );


  const handleNavigateToProductReview = (id) => {
    navigate(`/admin/product-review/${id}`);
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltips = Array.from(tooltipTriggerList).map((el) => {
      if (!el._tooltip) {
        return new window.bootstrap.Tooltip(el);
      }
      return el._tooltip;
    });
    return () => {
      tooltips.forEach((tooltip) => tooltip.dispose());
    };
  }, [data]);


  const orderPages = [
    "/admin/all-orders",
    "/admin/new-orders",
    "/admin/delivered-orders",
    "/admin/cancelled-orders",
    "/admin/pending-orders",
  ];

  const isOrderPage = orderPages.includes(currentPath);

  const filteredData =
    data?.filter((row) => {
      const matchesSearch = Object.values(row)
        .filter(v => v !== null && v !== undefined)
        .join(" ")
        .toLowerCase()
        .includes(searchText.toLowerCase());

      if (!isOrderPage) return matchesSearch;

      if (!row.created_at) return false;

      const rowDate = new Date(row.created_at);
      rowDate.setHours(0, 0, 0, 0);

      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start) start.setHours(0, 0, 0, 0);
      if (end) end.setHours(23, 59, 59, 999);

      const matchesStart = start ? rowDate >= start : true;
      const matchesEnd = end ? rowDate <= end : true;

      return matchesSearch && matchesStart && matchesEnd;
    }) || [];








  const columnWidths = {
    sl: "80px",
    status: "100px",
    approved_status: "140px",
    actions: "250px",
  };


  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const dateRangeText =
    startDate && endDate
      ? `Order Date: ${formatDate(startDate)} - ${formatDate(endDate)}`
      : startDate
        ? `Order Date: From ${formatDate(startDate)}`
        : endDate
          ? `Order Date: Until ${formatDate(endDate)}`
          : "Order Date: All Dates";


  const generateFileName = () => {
    // Extract the last part of the route, e.g., "all-products"
    const pathSegments = currentPath.split("/").filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1] || "report";

    // Optional: add date range for orders
    let datePart = "";
    if (isOrderPage && (startDate || endDate)) {
      const start = startDate ? formatDate(startDate) : "";
      const end = endDate ? formatDate(endDate) : "";
      datePart = start && end ? `-${start}-to-${end}` : `-${start || end}`;
    }

    // Clean filename: replace spaces or commas with hyphens
    const safeName = `${lastSegment}${datePart}`
      .replace(/[^a-z0-9-]/gi, "-")
      .toLowerCase();

    return safeName;
  };



  // const downloadPDF = () => {
  //   const doc = new jsPDF();

  //   // Title
  //   doc.setFontSize(14);
  //   doc.text("Orders Report", 14, 15);

  //   // Date Range
  //   doc.setFontSize(10);
  //   doc.text(dateRangeText, 14, 22);

  //   autoTable(doc, {
  //     startY: 28,
  //     head: [columns.map(col => col.toUpperCase())],
  //     body: filteredData.map(item =>
  //       columns.map(col => item[col])
  //     ),
  //   });

  //   doc.save("orders-report.pdf");
  // };
  const downloadPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(14);
    doc.text("Report", 14, 15);

    doc.setFontSize(10);
    doc.text(dateRangeText, 14, 22);

    autoTable(doc, {
      startY: 28,
      head: [columns.map((col) => col.toUpperCase())],
      body: filteredData.map((item) => columns.map((col) => item[col])),
    });

    doc.save(`${generateFileName()}.pdf`);
  };




  // const downloadExcel = () => {
  //   const worksheetData = [
  //     [dateRangeText],
  //     [],
  //     columns.map(col => col.toUpperCase()),
  //     ...filteredData.map(item =>
  //       columns.map(col => item[col])
  //     ),
  //   ];

  //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  //   XLSX.writeFile(workbook, "orders-report.xlsx");
  // };


  const downloadExcel = () => {
    const worksheetData = [
      [dateRangeText],
      [],
      columns.map((col) => col.toUpperCase()),
      ...filteredData.map((item) => columns.map((col) => item[col])),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `${generateFileName()}.xlsx`);
  };
const checkboxColumn = {
  name: "",
  width: "60px",
  cell: (row) => (
    <input
      type="checkbox"
      checked={selectedRows?.includes(row.id)}
      onChange={() => onSelectRow(row.id)}
    />
  ),
};

 const tableColumns = [
...(
  currentPath.includes("/admin/all-products") ||
  currentPath.includes("/admin/active-products") || 
   currentPath.includes("/admin/inactive-products") ||
    currentPath.includes("/admin/all-sold-products") || 
     currentPath.includes("/admin/all-offers-products")
    ? [checkboxColumn]
    : []
),

...columns
  .filter((col) => {
    const hiddenColumns = ["qty", "price", "sku"];

    return !hiddenColumns.includes(col.toLowerCase());
  })
  .map((col) => {
    const width = columnWidths[col];

    if (col === "status") {
      return {
        name: "STATUS",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.status}
              onChange={() => onToggleStatus && onToggleStatus(row)}
            />
          </div>
        ),
        sortable: true,
        width,
      };
    }

    // Toggle button for Customer Active Status
    if (col === "is_active") {
      return {
        name: "IS ACTIVE",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.is_active}
              onChange={() => onToggleStatus && onToggleStatus(row)}
              aria-label={`Toggle active status for ${row.username || "customer"}`}
            />
          </div>
        ),
        sortable: true,
        width: "120px",
      };
    }


    if (col === "show_at_home") {
      return {
        name: "SHOW AT HOME",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.show_at_home}
              onChange={() =>
                onToggleApprovedStatus && onToggleApprovedStatus(row)
              }
            />
          </div>
        ),
        sortable: true,
        width: "150px",
      };
    }

    if (col === "is_approved") {
      return {
        name: "APPROVAL",
        cell: (row) => (
          <select
            className="form-select form-select-sm"
            value={row.is_approved ? "approved" : "pending"}
            onChange={(e) =>
              onToggleApprovedStatus &&
              onToggleApprovedStatus(row, e.target.value)
            }
            style={{ minWidth: "100px", fontSize: "12px" }}
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
          </select>
        ),
        sortable: true,
        width,
      };
    }

    if (col === "is_default") {
      return {
        name: "DEFAULT",
        cell: (row) => {
          const isDefault = row[col] === 1 || row[col] === true;

          return (
            <div
              style={{
                backgroundColor: isDefault ? "#D1FAE5" : "#FECACA",
                color: isDefault ? "#065F46" : "#991B1B",
                padding: "4px 8px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {isDefault ? "Default" : "No"}
            </div>
          );
        },
        sortable: true,
        width,
      };
    }

    if (col === "is_featured") {
      return {
        name: "FEATURED",
        cell: (row) => {
          const isFeatured = row[col] === 1 || row[col] === true;
          return (
            <div
              style={{
                backgroundColor: isFeatured ? "#D1FAE5" : "#FECACA",
                color: isFeatured ? "#065F46" : "#991B1B",
                padding: "6px 18px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {isFeatured ? "Yes" : "No"}
            </div>
          );
        },
        sortable: true,
        width,
      };
    }

    if (
      col === "logo" ||
      col === "banner" ||
      col === "blog_image" ||
      col === "brand_logo" ||
      col === "thumb_image" ||
      col === "cat_image" ||
      col === "sub_cat_image" ||
      col === "image"
    ) {
      return {
        name: col
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        cell: (row) =>
          row[col] ? (
            <img
              src={
                row[col].startsWith("http")
                  ? row[col]
                  : `${process.env.REACT_APP_BASE_IMAGE_URL}${row[col]}`
              }
              alt={col}
              style={{ width: "80px", height: "50px", objectFit: "contain" }}
            />
          ) : (
            "No Image"
          ),
        sortable: false,
      };
    }

    return {
      name:
        col === "order_date"
          ? "ORDER DATE"
          : col === "product_type"
            ? "Type"
            : col.replace(/_/g, " ").toUpperCase(),
      cell: (row) => {
        let value = row[col];

        if (col === "product_type") {
          if (!value || typeof value !== "string" || value.trim() === "") {
            return (
              <div
                style={{
                  backgroundColor: "#000",
                  color: "#fff",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                None
              </div>
            );
          }

          let label = value
            .split(/[\s_]+/)
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");

          return (
            <div
              style={{
                backgroundColor: "#E5E7EB",
                color: "#000",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {label}
            </div>
          );
        }

        if (value && typeof value === "string") {
          value = value
            .split(/[\s_]+/)
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");
        }

        return (
          <div style={{ wordBreak: "break-word", maxWidth: "250px", fontSize: "12px" }}>
            {value}
          </div>
        );
      },
      sortable: true,
      width,
    };
  })
]

  // Hide ACTIONS column on these pages
  const hideActionsFor = [
    "/admin/customer-management",
    "/admin/transactions",
    "/admin/contact-us-list",
    "/admin/product-review",

  ];
  // const shouldShowActions = !hideActionsFor.includes(currentPath);
  const shouldShowActions = !hideActionsFor.some(path =>
    currentPath.startsWith(path)
  );


  const onView = (row) => {
    navigate(`/admin/order/${row.id}`);
  };

  //  Add Actions Column Only If Allowed
  if (shouldShowActions) {
    tableColumns.push({
      name: "ACTIONS",
      cell: (row) => (
        <div className="d-flex justify-content-center align-items-center position-relative">

          {[
            "/admin/all-orders",
            "/admin/new-orders",
            "/admin/delivered-orders",
            "/admin/cancelled-orders",
            "/admin/pending-orders",

          ].includes(currentPath) ? (
            <button
              onClick={() => onView(row)}
              className="btn btn-sm btn-primary"
              title="View"
            >
              <i className="bx bx-show"></i>
            </button>
          ) : (
            <>
              {/* <button
                onClick={() => onEdit(row)}
                className="btn btn-sm btn-primary me-2"
                title="Edit"
              >
                <i className="bx bx-edit"></i>
              </button> */}
              {/* Hide Edit Button on Product Image Gallery Page */}
              {!isProductGalleryPage && (
                <>
                  {onEditLink ? (
                    <a
                      href={onEditLink(row)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-primary me-2"
                      title="Edit"
                    >
                      <i className="bx bx-edit"></i>
                    </a>
                  ) : (
                    <button
                      onClick={() => onEdit(row)}
                      className="btn btn-sm btn-primary me-2"
                      title="Edit"
                    >
                      <i className="bx bx-edit"></i>
                    </button>
                  )}
                </>
              )}



              <button
                onClick={() => onDelete(row.id)}
                className="btn btn-sm btn-danger me-2"
                title="Delete"
              >
                <i className="bx bx-trash"></i>
              </button>
            </>
          )}

          {[
            "/admin/all-products",
            "/admin/active-products",
            "/admin/inactive-products",
          ].includes(currentPath) && (
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleSettingsClick(row.id)}
                  title="Settings"
                >
                  <i className="bx bx-cog"></i>

                </button>
                {openDropdownId === row.id && (
                  <div className="dropdown-menu show" style={{ top: "-80px", right: "20px", }}>
                    {/* <button
                      className="dropdown-item"
                      onClick={() => handleNavigateToGallery(row.id)}
                    >
                      Image Gallery
                    </button> */}
                    <a
                    href={`/admin/product-image-gallery/${row.id}`}
                    className="dropdown-item"
                  >
                    Image Gallery
                  </a>
                    <button
                      className="dropdown-item"
                      onClick={() => handleNavigateToProductReview(row.id)}
                    >
                      Product Review
                    </button>
                  </div>
                )}
              </div>
            )}
        </div>
      ),
      width: columnWidths.actions,
    });
  }

  const customStyles = {
    headRow: {
      style: {
        fontWeight: "600",
        fontSize: "12px",
        backgroundColor: "#3b82f6",
        color: "#fff",
      },
    },
  };


const productManagePaths = [
  "/admin/all-products",
  "/admin/active-products",
  "/admin/inactive-products",
  "/admin/out-of-stock-products",
  "/admin/all-sold-products",
  "/admin/all-offers-products",
];

const isProductManagePage = productManagePaths.some(
  (path) => currentPath === path || currentPath.startsWith(`${path}/`)
);

const hideExportButtonsFor = ["/admin/sliders"];

const shouldShowExportButtons =
  !isProductManagePage &&
  !hideExportButtonsFor.some(
    (path) => currentPath === path || currentPath.startsWith(`${path}/`)
  );




  return (
    <>


      <div className="d-flex align-items-end justify-content-end gap-3 mb-3">
        {/* Export Buttons */}
        {shouldShowExportButtons && (
          <div className="d-flex flex-wrap gap-2">
            <button
              className="btn btn-success"
              onClick={downloadExcel}
            >
              Download Excel
            </button>

            <button
              className="btn btn-danger"
              onClick={downloadPDF}
            >
              Download PDF
            </button>
          </div>
        )}
      </div>

      <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between gap-3 mb-3">


        {/* Filters + Search */}
        <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2 ms-md-auto">

          {/* Date Filters – ONLY for Order Pages */}
       {isOrderPage && externalStartDate === undefined && (
            <>
              <input
                type="date"
                className="form-control text-dark"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />

              <input
                type="date"
                className="form-control text-dark"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />

              {(startDate || endDate) && (
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    setStartDate("");
                    setEndDate("");
                  }}
                >
                  Clear
                </button>
              )}
            </>
          )}

          {/* Search – ALWAYS visible */}
    {externalSearchText === undefined && (
  <input
    type="text"
    placeholder="Search..."
    className="form-control"
    style={{ minWidth: "220px" }}
    value={internalSearchText}
    
    onChange={(e) => setInternalSearchText(e.target.value)}
  />
)}
        </div>
      </div>



      <DataTable
        columns={tableColumns}
        // data={data}
        data={filteredData}

        pagination
        highlightOnHover
        striped
        responsive
        customStyles={customStyles}
      />
    </>
  );
}
